import { Link, useLocation } from "react-router-dom";
import { AlertTriangle, Loader2 } from "lucide-react";
import { useFeatures } from "@/context/FeaturesContext";
import { isTenantWriteBlocked } from "@/lib/tenantBillingAccess";

export default function BillingAccessGate({ children }) {
  const location = useLocation();
  const { access, loading } = useFeatures();

  if (loading) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white p-8 text-center text-sm text-slate-500">
        <Loader2 className="mr-2 inline h-4 w-4 animate-spin" />
        Checking billing access…
      </div>
    );
  }

  if (!isTenantWriteBlocked(access, location.pathname)) return children;

  return (
    <div className="mx-auto max-w-2xl rounded-2xl border border-amber-200 bg-amber-50 p-6 text-amber-950 shadow-sm">
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-700" />
        <div>
          <h1 className="text-lg font-semibold">Billing read-only mode</h1>
          <p className="mt-2 text-sm text-amber-900">
            This tenant can still view records and schedules, but new clinical, checkout, team, and settings changes are blocked until billing is restored.
          </p>
          <Link
            to="/settings/billing"
            className="mt-4 inline-flex rounded-lg bg-amber-900 px-3 py-2 text-sm font-semibold text-white hover:bg-amber-800"
          >
            Open Billing
          </Link>
        </div>
      </div>
    </div>
  );
}
